import React, { Component } from 'react';
import * as Request from '../../service/data-info-chart/requestsUtil';
import '../../../node_modules/rc-rate/assets/index.css';
import view from '../../resources/images/estrategas/tools/view.svg';


class ViewWithTimeStamp extends Component {

  constructor(props) {
    super(props);
    this.viewReport = this.viewReport.bind(this);
  }

  viewReport() {
    Request.getFetch(this.props.url)
      .then(resp => {
        window.open(resp.url);
      });
  }

  render() {
    return (
      <div className='quality-edit'>
        <img src={view} title="Ver" alt=" " onClick={this.viewReport}/>
      </div>
    );
  }
}

export default ViewWithTimeStamp;



// WEBPACK FOOTER //
// ./src/components/buttons/viewWithTimeStamp.js